import { selector } from 'recoil'
import projectTypesAtom from './projectTypes.atom'
import { ProjectTypesMap } from './projectTypes.types'

const projectTypesMap = selector({
  key: 'selectors/project-Types-map',
  get: ({ get }): ProjectTypesMap=> {
    const projectTypesState = get(projectTypesAtom)

    return projectTypesState.items.reduce((acc, val) => ({ ...acc, [val.id]: val}), {})
  },
})

const projectTypesSelectors = { projectTypesMap }
export default projectTypesSelectors
